// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"bea955cf","297":"fb0ba005","828":"eb94857c"}[chunkId] + ".chunk.js";
};